import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';

const TABLE_SEARCH_TYPES = {
  SOURCE: 'origin',
  PROPERTY: 'property',
  OPERATION: 'operation',
  PROPERTY_TYPE: 'property_type',
  CONTACT: 'contact',
  ORIGIN: 'origin',
  AGENT: 'agent',
  VISIT_TYPE: 'visit_type',
  LOCATION: 'location',
  OWNER: 'owner',
  PRODUCER: 'producer',
  BRANCH: 'branch',
  DEVELOPMENT: 'development',
  DEVELOPMENT_TYPE: 'development_type',
  DEVELOPMENT_STATUS: 'development_status',
  AGENTS_IN_CHARGE: 'agents_in_charge',
  RESERVATION_STATUS: 'reservation_status',
  CLOSING_REASON: 'closing_reason',
  EVENT_TYPE: 'event_type',
  EVENT_DATE: 'event_date',
};

const TABLE_SEARCH_STATUS = {
  ALL: null,
  IN_PROGRESS: 'in_progress',
  CONCRETED: 'completed', // "Concreted" is the text, "completed" is the value
  LOST: 'lost',
  ENABLED_AGENTS: 'enabled_agents',
};

export const contactTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.SOURCE,
    text: Trans(translations, 'Source'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'AgentOrBranch'),
  },
];

export const contactStatusOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_STATUS.ALL,
    text: Trans(translations, 'NewContactsTableSearchStatus.All'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_STATUS.IN_PROGRESS,
    text: Trans(translations, 'NewContactsTableSearchStatus.InProgress'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_STATUS.CONCRETED,
    text: Trans(translations, 'NewContactsTableSearchStatus.Concreted'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_STATUS.LOST,
    text: Trans(translations, 'NewContactsTableSearchStatus.Lost'),
  },
];

export const inquiryTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.ORIGIN,
    text: Trans(translations, 'Origin'),
  },
  {
    id: 6,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
];

export const doneVisitsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.VISIT_TYPE,
    text: Trans(translations, 'VisitType'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
];

export const getDoneVisitsTypesOptions = (hasNewEventTypeConfig) => {
  if (!hasNewEventTypeConfig) return doneVisitsTypesOptions;

  return [
    ...doneVisitsTypesOptions,
    {
      id: 5,
      value: TABLE_SEARCH_TYPES.CLOSING_REASON,
      text: Trans(translations, 'ClosingReason'),
    },
  ];
};

export const doneEventsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.EVENT_TYPE,
    text: Trans(translations, 'EventType'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
];

export const getDoneEventsTypesOptions = (hasNewEventTypeConfig) => {
  if (!hasNewEventTypeConfig) return doneEventsTypesOptions;

  return [
    ...doneEventsTypesOptions,
    {
      id: 5,
      value: TABLE_SEARCH_TYPES.CLOSING_REASON,
      text: Trans(translations, 'ClosingReason'),
    },
  ];
};

export const responseTimeTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },

  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.LOCATION,
    text: Trans(translations, 'Location'),
  },
];

export const addedPropertiesTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },

  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.OWNER,
    text: Trans(translations, 'Owner'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.PRODUCER,
    text: Trans(translations, 'Producer'),
  },
  {
    id: 6,
    value: TABLE_SEARCH_TYPES.BRANCH,
    text: Trans(translations, 'Branch'),
  },
];

export const conversionTimeTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.BRANCH,
    text: Trans(translations, 'Branch'),
  },

  {
    id: 3,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.LOCATION,
    text: Trans(translations, 'Location'),
  },
  {
    id: 6,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },
];

export const conversionTimeStatusOptions = [
  {
    id: 1,
    value: 'all',
    text: Trans(translations, 'DashboardTablesDropdown.AllAgentsEvenDisabled'),
  },
  {
    id: 2,
    value: 'enabled_agents',
    text: Trans(translations, 'DashboardTablesDropdown.AgentsEnabled'),
  },
];

export const conversionRateStatusOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_STATUS.ALL,
    text: Trans(
      translations,
      'NewContactsTableSearchStatus.AllAgentsEvenDisabled'
    ),
  },
  {
    id: 2,
    value: TABLE_SEARCH_STATUS.ENABLED_AGENTS,
    text: Trans(translations, 'NewContactsTableSearchStatus.AgentsEnabled'),
  },
];

export const productionRateStatusOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_STATUS.ALL,
    text: Trans(
      translations,
      'NewContactsTableSearchStatus.AllAgentsEvenDisabled'
    ),
  },
  {
    id: 2,
    value: TABLE_SEARCH_STATUS.ENABLED_AGENTS,
    text: Trans(translations, 'NewContactsTableSearchStatus.AgentsEnabled'),
  },
];

export const concretedOperationsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },

  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.ORIGIN,
    text: Trans(translations, 'Origin'),
  },
  {
    id: 6,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
  {
    id: 7,
    value: TABLE_SEARCH_TYPES.BRANCH,
    text: Trans(translations, 'Branch'),
  },
];

export const propertyConsultationsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },

  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.OWNER,
    text: Trans(translations, 'Propietary'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.PRODUCER,
    text: Trans(translations, 'Producer'),
  },
];

export const developmentConsultationsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.DEVELOPMENT,
    text: Trans(translations, 'Development'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.DEVELOPMENT_TYPE,
    text: Trans(translations, 'DevelopmentType'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.DEVELOPMENT_STATUS,
    text: Trans(translations, 'DevelopmentStatus'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.AGENTS_IN_CHARGE,
    text: Trans(translations, 'Agent'),
  },
];

export const closedLeadsTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.BRANCH,
    text: Trans(translations, 'Branch'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.CLOSING_REASON,
    text: Trans(translations, 'ClosingReason'),
  },
];

export const reservationsCreatedTypesOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_TYPES.PROPERTY,
    text: Trans(translations, 'Property'),
  },
  {
    id: 2,
    value: TABLE_SEARCH_TYPES.OPERATION,
    text: Trans(translations, 'Operation'),
  },
  {
    id: 3,
    value: TABLE_SEARCH_TYPES.PROPERTY_TYPE,
    text: Trans(translations, 'PropertyType'),
  },
  {
    id: 4,
    value: TABLE_SEARCH_TYPES.CONTACT,
    text: Trans(translations, 'Contact'),
  },
  {
    id: 5,
    value: TABLE_SEARCH_TYPES.AGENT,
    text: Trans(translations, 'Agent'),
  },
  {
    id: 6,
    value: TABLE_SEARCH_TYPES.BRANCH,
    text: Trans(translations, 'Branch'),
  },
  {
    id: 7,
    value: TABLE_SEARCH_TYPES.RESERVATION_STATUS,
    text: Trans(translations, 'ReservationStatus'),
  },
];

export const agentsPerformanceStatusOptions = [
  {
    id: 1,
    value: TABLE_SEARCH_STATUS.ALL,
    text: Trans(
      translations,
      'NewContactsTableSearchStatus.AllAgentsEvenDisabled'
    ),
  },
  {
    id: 2,
    value: TABLE_SEARCH_STATUS.ENABLED_AGENTS,
    text: Trans(translations, 'NewContactsTableSearchStatus.AgentsEnabled'),
  },
];
